import { useEffect } from 'react';

// Небольшой инлайновый лоадер (кружок с вращением)
// Использование: <SmallLoader /> или <SmallLoader inline />
const SmallLoader = ({ size = 16, color = '#fff', inline = false, className = '' }) => {
  useEffect(() => {
    // Инъекция стилей один раз
    if (!document.getElementById('small-loader-styles')) {
      const style = document.createElement('style');
      style.id = 'small-loader-styles';
      style.innerHTML = `@keyframes small-loader-spin {from {transform: rotate(0deg);} to {transform: rotate(360deg);} }`;
      document.head.appendChild(style);
    }
  }, []);

  const style = {
    width: size,
    height: size,
    border: `${Math.max(2, Math.round(size / 8))}px solid rgba(255,255,255,0.4)`,
    borderTopColor: color,
    borderRadius: '50%',
    animation: 'small-loader-spin 0.6s linear infinite',
    display: 'inline-block',
    verticalAlign: 'middle',
  };

  return (
    <span
      className={`small-loader ${inline ? 'small-loader--inline' : ''} ${className}`.trim()}
      style={style}
      aria-hidden="true"
    />
  );
};

export default SmallLoader;
